var React = require('react');

function Rocket (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 66C12 71.04 10 86 10 86C10 86 24.96 84 30 78C32.84 74.64 32.8 69.48 29.64 66.36C28.0852 64.876 26.0372 64.0185 23.8889 63.9521C21.7406 63.8857 19.6435 64.615 18 66ZM48 60L36 48C38.1286 42.4777 40.8088 37.1843 44 32.2C48.6607 24.7479 55.1505 18.6122 62.852 14.3764C70.5535 10.1405 79.2107 7.94548 88 8C88 18.88 84.88 38 64 52C58.9475 55.1949 53.5874 57.875 48 60Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M36 48H16C16 48 18.2 35.88 24 32C30.48 27.68 44 32 44 32M48 60V80C48 80 60.12 77.8 64 72C68.32 65.52 64 52 64 52","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Rocket.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Rocket;

Rocket.default = Rocket;
